import { render } from "./registerForm.vue?vue&type=template&id=0c56a926"
import script from "./registerForm.vue?vue&type=script&lang=ts"
export * from "./registerForm.vue?vue&type=script&lang=ts"

import "./registerForm.vue?vue&type=style&index=0&id=0c56a926&lang=scss"
script.render = render

export default script